var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Directive, ElementRef, Input, ContentChildren, ContentChild, QueryList, ChangeDetectionStrategy, forwardRef, HostBinding, Optional, Renderer2 } from '@angular/core';
import { IsBoolean } from 'alyle-ui/core';
import { AnimationBuilder, trigger, state, animate, transition, style } from '@angular/animations';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var LyDrawerContent = /** @class */ (function () {
    function LyDrawerContent(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.margin = '0 0 0 0';
        this._lyAnimation = true;
        this._el = elementRef.nativeElement;
    }
    LyDrawerContent.prototype.setContentStyle = function (margin) {
        var array = this.margin.split(' ');
        if (margin.left) {
            array[3] = margin.left + "px";
        }
        if (margin.right) {
            array[1] = margin.right + "px";
        }
        if (margin.top) {
            array[0] = margin.top + "px";
        }
        if (margin.bottom) {
            array[2] = margin.bottom + "px";
        }
        this.margin = array.join(' ');
        // const keys = Object.keys(margin);
        // for (let i = 0; i < keys.length; i++) {
        //   const keyName = keys[i];
        //   this.renderer.setStyle(this._drawerContent.elementRef.nativeElement, `margin-${keyName}`, `${margin[keyName]}px`);
        // }
    };
    LyDrawerContent.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-drawer-content'
                },] },
    ];
    /** @nocollapse */
    LyDrawerContent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    LyDrawerContent.propDecorators = {
        "margin": [{ type: HostBinding, args: ['style.margin',] },],
        "_lyAnimation": [{ type: HostBinding, args: ['class.ly--animation',] },],
    };
    return LyDrawerContent;
}());
export { LyDrawerContent };
var LyDrawerContainer = /** @class */ (function () {
    function LyDrawerContainer(renderer, elementRef, animationBuilder) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.animationBuilder = animationBuilder;
        this.isDrawerBg = new BehaviorSubject(false);
    }
    LyDrawerContainer.prototype._closeAllSideAndPush = function () {
        var _this = this;
        this._drawers.forEach(function (drawer) {
            if (drawer.mode === 'over' || drawer.mode === 'push') {
                drawer.close();
                _this.isDrawerBg.next('inactive');
            }
        });
    };
    /** Close all open drawers */
    /** Close all open drawers */
    LyDrawerContainer.prototype.closeAll = /** Close all open drawers */
    function () {
        this._drawers.forEach(function (drawer) {
            if (drawer.open) {
                drawer.close();
            }
        });
        this.isDrawerBg.next('inactive');
    };
    LyDrawerContainer.decorators = [
        { type: Component, args: [{
                    selector: 'ly-drawer-container',
                    styles: [":host { display: block; overflow: hidden; -webkit-overflow-scrolling: touch; box-sizing: border-box; position: relative; } :host ::ng-deep > ly-drawer-content { height: 100%; overflow: auto; display: block; } :host ::ng-deep > ly-drawer-content.ly--animation { transition: 375ms cubic-bezier(0.45, 0, 0.25, 1); } .ly-drawer-bg { position: absolute; top: 0; left: 0; right: 0; bottom: 0; opacity: .6; z-index: 10; user-select: none; } .ly-drawer-bg-opened { display: block; } .ly-drawer-bg-closed { display: none; } "],
                    animations: [
                        trigger('in', [
                            state('inactive, 0', style({ opacity: '0', 'display': 'none' })),
                            state('active, 1', style({ opacity: '.6' })),
                            transition('* => active', animate('375ms ease-in')),
                            transition('* => inactive', animate('375ms ease-out')),
                        ])
                    ],
                    template: "\n  <ng-content select=\"ly-drawer\"></ng-content>\n  <ng-content select=\"ly-drawer-content\"></ng-content>\n  <div\n  #bg\n  [class.ly-drawer-bg-opened]=\"isDrawerBg | async\"\n  [class.ly-drawer-bg-closed]=\"!(isDrawerBg | async)\"\n  [@in]=\"isDrawerBg | async\" class=\"ly-drawer-bg\"\n  bg=\"colorText\"\n  (click)=\"_closeAllSideAndPush()\"\n  ></div>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                    exportAs: 'lyDrawerContainer'
                },] },
    ];
    /** @nocollapse */
    LyDrawerContainer.ctorParameters = function () { return [
        { type: Renderer2, },
        { type: ElementRef, },
        { type: AnimationBuilder, },
    ]; };
    LyDrawerContainer.propDecorators = {
        "_drawers": [{ type: ContentChildren, args: [forwardRef(function () { return LyDrawer; }),] },],
        "_drawerContent": [{ type: ContentChild, args: [forwardRef(function () { return LyDrawerContent; }),] },],
    };
    return LyDrawerContainer;
}());
export { LyDrawerContainer };
var LyDrawer = /** @class */ (function () {
    function LyDrawer(drawerContainer, elementRef) {
        this.drawerContainer = drawerContainer;
        this.elementRef = elementRef;
        this._opened = false;
        this.config = {
            width: 200,
            height: 200
        };
        this.mode = 'side';
        this.position = 'left';
        this.isOpenDrawer = false;
        this.isDrawerHidden = true;
    }
    Object.defineProperty(LyDrawer.prototype, "opened", {
        get: function () { return this._opened; },
        set: function (val) {
            this.isOpenDrawer = val;
            this._opened = val;
            val ? this.open(true) : this.close(false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyDrawer.prototype, "_elementRect", {
        get: function () {
            return this.elementRef.nativeElement.getBoundingClientRect();
        },
        enumerable: true,
        configurable: true
    });
    LyDrawer.prototype.updateDrawerMargin = function () {
        if (this.mode === 'side' || this.mode === 'push') {
            var width = this.config.width;
            var height = this.config.height;
            if (width !== 0 && this.position === 'left' || this.position === 'right') {
                var margin = {};
                margin[this.position] = width;
                this.drawerContainer._drawerContent.setContentStyle(margin);
            }
            if (height !== 0 && this.position === 'top' || this.position === 'bottom') {
                var margin = {};
                margin[this.position] = height;
                this.drawerContainer._drawerContent.setContentStyle(margin);
            }
        }
    };
    LyDrawer.prototype.toBoolean = function (drawerState) {
        if (drawerState === true || drawerState === 'open') {
            return true;
        }
        else {
            return false;
        }
    };
    LyDrawer.prototype.toggle = function () {
        this.toBoolean(this.isOpenDrawer) ? this.close() : this.open();
    };
    LyDrawer.prototype.open = function (is) {
        this.toogleDrawer(is);
        this.isDrawerHidden = false;
        this.isOpenDrawer = is || 'open';
        this.drawerContainer._drawerContent._lyAnimation = this.isOpenDrawer === 'open';
        this.updateDrawerMargin();
        this.setBgState(is || 'active');
        return this.isOpenDrawer;
    };
    LyDrawer.prototype.close = function (is) {
        this.toogleDrawer(is);
        this.resetMargin();
        this.isOpenDrawer = is === false || is === true ? false : 'close';
        this.drawerContainer._drawerContent._lyAnimation = this.isOpenDrawer === 'close';
        this.setBgState(is === false ? false : 'inactive');
        return this.isOpenDrawer;
    };
    LyDrawer.prototype.toogleDrawer = function (status) {
        this.isShowDrawer = this.toBoolean(status);
    };
    LyDrawer.prototype.setBgState = function (bgState) {
        if (this.mode === 'over' || this.mode === 'push') {
            this.drawerContainer.isDrawerBg.next(bgState);
        }
    };
    LyDrawer.prototype.resetMargin = function () {
        var margin = {};
        margin[this.position] = '0';
        this.drawerContainer._drawerContent.setContentStyle(margin);
    };
    LyDrawer.prototype.ngOnChanges = function (changes) {
        var _this = this;
        Object.keys(changes).forEach(function (key) {
            /**for `position` changes */
            if (key === 'position' && changes[key].currentValue === 'rtl') {
                _this.position = 'right';
            }
            /** Update mode */
            if (changes['mode'] && !changes[key].firstChange) {
                _this.toBoolean(_this.isOpenDrawer) ? _this.open(true) : _this.close(false);
            }
        });
    };
    LyDrawer.decorators = [
        { type: Component, args: [{
                    selector: 'ly-nav, ly-drawer',
                    styles: [":host { display: block; position: fixed; box-sizing: border-box; overflow: auto; z-index: 11; } :host[position=top] { top: 0; transform: translate3d(0, -100%, 0); } :host[position=left] { left: 0; transform: translate3d(-100%, 0, 0); } :host[position=right], :host[position=rtl] { right: 0; transform: translate3d(100%, 0, 0); } :host[position=bottom] { bottom: 0; transform: translate3d(0, 100%, 0); } :host.ly-show-drawer { transform: translate3d(0, 0, 0); } :host.ly-drawer-hidden { visibility: hidden; } "],
                    animations: [
                        trigger('visibilityChanged', [
                            state('true, open', style({ transform: 'translate3d(0, 0, 0)' })),
                            transition('* => open, * => close', [
                                animate('375ms cubic-bezier(.45, 0, .25, 1)')
                            ])
                        ])
                    ],
                    template: "<ng-content></ng-content>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    preserveWhitespaces: false,
                    exportAs: 'lyDrawer'
                },] },
    ];
    /** @nocollapse */
    LyDrawer.ctorParameters = function () { return [
        { type: LyDrawerContainer, decorators: [{ type: Optional },] },
        { type: ElementRef, },
    ]; };
    LyDrawer.propDecorators = {
        "config": [{ type: Input },],
        "mode": [{ type: HostBinding, args: ['attr.mode',] }, { type: Input },],
        "position": [{ type: HostBinding, args: ['attr.position',] }, { type: Input },],
        "isShowDrawer": [{ type: HostBinding, args: ['class.ly-show-drawer',] },],
        "isOpenDrawer": [{ type: HostBinding, args: ['@visibilityChanged',] },],
        "isDrawerHidden": [{ type: HostBinding, args: ['class.ly-drawer-hidden',] },],
        "opened": [{ type: Input },],
    };
    __decorate([
        IsBoolean(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], LyDrawer.prototype, "opened", null);
    return LyDrawer;
}());
export { LyDrawer };
//# sourceMappingURL=drawer.js.map